import React, { ReactElement, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS, PAGE_QUERY_PARAM } from '../../../../shared/constants/commonConstants';
import { INVENTORY_FETCH_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import { FetchInPatientPackageRequest, FetchInPatientPackageResponse } from '../../../../shared/models/inPatient.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, base64UrlEncode, error, extractSecondLevelBaseUrl, GetFirstElement } from '../../../../utils/utility';
import IPPackageForm from './IPPackageForm';

const EditIPPackage = ({ match: { path, params: { id: packageId } } }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [packageDetail, setPackageDetail] = useState(null as any);
  const id = base64UrlDecode(packageId);
  useEffect((): void => {
    const reqpayload: FetchInPatientPackageRequest = {
      fetchInActiveRecord: true,
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      packageById: true,
      ids: [+id],
      packageType: INVENTROY_CONSTANTS.packageType_InPatient,
    };
    fetchPackageDetail(reqpayload);
  }, [id]);
  const fetchPackageDetail = async (
    payload: any,
  ): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_FETCH_IP_PACKAGE;
    const result: FetchInPatientPackageResponse = await SendRequest.instance.post<
      FetchInPatientPackageRequest,
      FetchInPatientPackageResponse
    >(url, payload);
    if (result && result?.isSuccess && result?.packages && result?.packages?.length > 0) {
      setPackageDetail(GetFirstElement(result?.packages));
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.tryAgain);
    }
  };
  return (
    <div>
      <IPPackageForm
        backUrl={
          extractSecondLevelBaseUrl(path) +
          INVENTROY_CONSTANTS.ipPackageDetailRoute + base64UrlEncode(packageDetail?.id) + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        pageTitle={packageDetail?.procedureName} data={packageDetail}
        path={path} />
    </div>
  );
};

export default EditIPPackage;
